<template>
    <div>
        <TheHeader class="mob-header" />
        <template>
            <BaseTitle 
                :infor="infor" 
            />
            <div class="banner">
                <img :src="infor.banner">
            </div>
            <BaseText 
                class="service-desc" 
                :text="text" 
            />
            <div class="service-list">
                <div class="service-list-title" v-html="serviceList.title"></div>
                <BaseListUlmoudle1 class="service-list-ul" :list="serviceList"/>
            </div>    
        </template>
        <TheFooter class="mob-the-footer-other" />
    </div>
</template>

<script>

    import TheHeader from '@/components/module/TheHeader'
    import TheFooter from '@/components/module/TheFooter'
    import '@/assets/less/module/module-the-header_mob-header.less'
    import '@/assets/less/module/module-the-footer-other_mob-the-footer-other.less'

    import BaseTitle from '@/components/module/BaseTitle'
    import BaseText from '@/components/module/BaseText'
    import BaseListUlmoudle1 from '@/components/module/BaseListUlmoudle1'

    import '@/assets/less/module/module-base-list-ulmoudle1_service-list-ul.less'

    export default {
        
        name: 'MobService',
        props: {
            json: Object
        },
        components: {
            TheHeader,
            TheFooter,
            BaseTitle,
            BaseText,
            BaseListUlmoudle1
        },
        computed: {
            infor: function(){
                let json = JSON.parse(JSON.stringify(this.json));
                let infor = json.infor;
                infor.banner = infor.mobBanner;
                return infor;
            },
            text: function(){
                let json = JSON.parse(JSON.stringify(this.json));
                let text = json.text;
                return text;
            },
            serviceList: function(){
                let json = JSON.parse(JSON.stringify(this.json));
                let serviceList = json.serviceList;
                let arr = serviceList.content.list;
                for(var i=0, l=arr.length; i<l; i++) {
                    arr[i].image = arr[i].mobImage;
                }
                return serviceList;
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>


.title-box {
    padding-bottom: .32rem;
}
.service-desc {
    padding-top: .533rem;
}

.service-list {
    width: 9.04rem;
    margin: 0 auto;
}

.service-list-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    min-height: .533rem;
    padding-left: .266rem;
    border-left: 2px #333 solid;
    margin-bottom: .533rem;
    font-size: .373rem;
    font-weight: bold;
}

</style>